const s = "https://opyx-mtds-pro.oss-cn-shenzhen.aliyuncs.com/QUAP/packageFile/1209546967858343936.png";
export {
  s as DEFAULT_IMAGE
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/constants/index.js
// module id = 1298
// module chunks = 41